import PropTypes from 'prop-types';
import React from 'react';
import Button from 'yoda-core-components/lib/components/Button/Button';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Capitalize from '../../helpers/Capitalize';
import ProductConstants from '../../helpers/ProductConstants';

const BrandLink = (props) => {
    const {
        productDetails: { brand = {} },
    } = props;
    const { SHOP_ALL } = ProductConstants;
    return (
        brand.brandPageUrl && (
            <p
                className={dt(['font-open-sans-regular', 'text-small', 'text-black'])}
                data-automation-id="at-brand-link-block"
            >
                {SHOP_ALL}{' '}
                <Button
                    buttonType="Link"
                    size="Sm"
                    type="linkbutton"
                    linkUrl={brand.brandPageUrl}
                    automationId="at-brand-link-btn"
                    className={dt(['!font-normal'])}
                >
                    {Capitalize.toCapitalize(brand.name)}
                </Button>
            </p>
        )
    );
};

BrandLink.defaultProps = {
    productDetails: {},
};

BrandLink.propTypes = {
    productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default BrandLink;
